const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchProductsApi = async () => {
  const response = await fetch(`${API_BASE_URL}/api/products/list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }

  const result = await response.json();
  console.log(result);
  return result.data.content;
};
